// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__AOdzu","title":"Images45_title__d6waq","images":"Images45_images__2tXIO"};